import React from 'react';
import { Card } from 'antd';

import { COMPANY_PACKING_DAYS_GUARANTEE } from '../../../config';

import PageTitle from '../../../components/PageTitle';
import ShippingAddress from '../../../components/ShippingAddress';

import './index.css';

function Tutorial() {
  return (
    <div className="Tutorial">
      <PageTitle>转运教程</PageTitle>

      <Card bordered={false}>
        <div className="Tutorial-content">
          <p>1. 在本站注册用户，系统会自动生成四位字母会员号，是你邮寄包裹和使用系统的唯一标识</p>
          <p>2. 电商网站下单或让家人邮寄包裹至我们仓库，地址格式如下(单击每行即可复制)：</p>
          <ShippingAddress />
          <p>
            3.
            电商网站发货后，在本站预报包裹，可以选择拼邮或者直邮，准确填写国内快递单号等信息。稍后可以在我的包裹中查看状态，入库后可以看到包裹重量。如果预报时包裹已被签收，则有可能已被仓库操作入库并且绑定到你的账号，此时包裹默认是直邮类型，需要的话可以在我的包裹中修改成拼邮
          </p>
          <p>4. 打包发货</p>
          <p>
            直邮：待你需要邮寄的包裹全部入库后，可以在我的包裹页面勾选一个或多个包裹申请打包，并提供收货地址。操作员收到订单后会微信联系你确认物流渠道，然后在
            {COMPANY_PACKING_DAYS_GUARANTEE} 个工作日内完成打包并通知你付款，付款完成后会在 {COMPANY_PACKING_DAYS_GUARANTEE}
            个工作日内完成出库并发出。你可以在我的订单中查看订单的重量、运费以及状态
          </p>
          <p>
            拼邮：待你所选的拼邮团截团后，系统会自动生成拼邮子订单，仓库会在 {COMPANY_PACKING_DAYS_GUARANTEE}
            个工作日内完成打包，打包完会更新子订单，并在系统通知中告知运费付款(不会在微信群里通知)，可以在「我的订单」中查看自己的运费和包裹。所有订单包裹一律付款后发货，如未付款延迟发货概不负责。在截团后才入库的包裹不会被打包进去，系统会自动创建跟原拼邮团同名的团，并把所有截团后入库的包裹自动加入，稍后你也可以修改包裹，加入其它拼邮团。包裹到达目的国后将运送至团长处，团长会在微信群通知大家取货，大家自行到团长处领取包裹
          </p>
        </div>
      </Card>
    </div>
  );
}

export default Tutorial;
